import markerSDK from '@marker.io/browser'

export default defineNuxtPlugin(() => {
  markerSDK.loadWidget({
    project: '654d00146bb41eb03c5a44d9',
  })
})
